// src/api/apiClient.ts
import axios, { AxiosError, AxiosResponse } from "axios";
import { SERVER_URL } from "../utils/config";

const API_BASE_URL = `${SERVER_URL}/api`; // Replace with your API URL

// ✅ Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000, // 10 seconds
});

// ✅ Define response type like Supabase
export interface ApiResponse<T> {
  data: T | null;
  error: { status?: number; message: string } | null;
}

// ✅ Handle API responses globally
apiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    const message =
      (error.response?.data as any)?.message ||
      error.message ||
      "Something went wrong. Please try again.";

    console.error("API Error:", {
      url: error.config?.url,
      status: error.response?.status,
      message,
    });

    return Promise.reject({
      status: error.response?.status,
      message,
    });
  }
);

// ✅ Supabase-style API wrapper
export const api = {
    async get<T>(endpoint: string, params = {}): Promise<ApiResponse<T>> {
        try {
          const { data } = await apiClient.get<T>(endpoint, { params });
          return { data, error: null };
        } catch (error: any) {
          return { data: null, error };
        }
      }
,      

  async post<T>(endpoint: string, body: any): Promise<ApiResponse<T>> {
    try {
      const { data } = await apiClient.post<T>(endpoint, body);
      return { data, error: null };
    } catch (error: any) {
      return { data: null, error };
    }
  },

  async put<T>(endpoint: string, body: any): Promise<ApiResponse<T>> {
    try {
      const { data } = await apiClient.put<T>(endpoint, body);
      return { data, error: null };
    } catch (error: any) {
      return { data: null, error };
    }
  },

  async delete<T>(endpoint: string): Promise<ApiResponse<T>> {
    try {
      const { data } = await apiClient.delete<T>(endpoint);
      return { data, error: null };
    } catch (error: any) {
      return { data: null, error };
    }
  },
};

export default apiClient;
